module.exports = __webpack_public_path__ + "static/media/flyer1-image.8fd88c1b.png";